module.exports = __webpack_public_path__ + "img/icon_vivo.239a678e.svg";